import React, { useEffect } from "react";
import { post} from "../Services/http";

const CadVisualizer = () => {
    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event.data.type === 'litium.requestQuoteProductData') {
                post("/api/cart/addDynamakerCartItemModelV4", event.data.data)
                    .then(res => res.json())
                    .then(res => window.location.href = res.checkoutUrl)
            }
            
            if (event.data.type === 'downloadLogger') {
                post("/api/dynamaker/download/log", event.data.content)
            }
            if (event.data.type === 'UpdatePartConfiguration') {
                post("/api/cart/addDynamakerCartItemModelV2", event.data)
                    .then(res => res.json())
                    .then(res => window.location.href = res.checkoutUrl)
            }
            
        })
    })
    
    return(
        <div>
        </div>
    )
}


export default CadVisualizer;